import { toFormikValidationSchema } from "zod-formik-adapter";

import type { IShapeOfForm } from "@utils";
import { z } from "@utils";

export interface IGuestJoinFormValues {
  name: string;
}

export const guestJoinInitialValues: IGuestJoinFormValues = {
  name: "",
};

export const guestJoinSchema = toFormikValidationSchema(
  z.object<IShapeOfForm<IGuestJoinFormValues>>({
    name: z.string().trim().min(1).max(20),
  }),
);
